
import { useState } from "react"
import FreeTrialForm from "../../features/freetrial/FreeTrialForm"

const FreeTrial = () => {
    const [isFreeTrialModalOpen, setFreeTrialModalOpen] = useState(false)

    return (
        <section className="section freetrial" aria-label="freetrial">
            <div className="container">
                <div className="freetrial-content">
                    <h3 className="h3 freetrial-title">
                        Start Your Free Trial
                    </h3>

                    <p className="freetrial-text">
                        Get hands-on with Advisors Reserve in minutes--no credit card, no commitment. Try all features for 30 days!
                    </p>

                    <div className="btn-wrapper">
                        <a className="btn freetrial-btn-primary" onClick={() => setFreeTrialModalOpen(true)}>Start Trial Now</a>
                    </div>
                </div>
            </div>

            {isFreeTrialModalOpen && <FreeTrialForm isModalOpen={isFreeTrialModalOpen} onClose={() => setFreeTrialModalOpen(false)} />}
        </section>
    )
}

export default FreeTrial